<template>
  <div class="my-feedback">
    <div class="feeback-content" @click="drawer = true" v-if="this.$route.path != '/login'">
      <i>
        <img src="./img/edit.png">
      </i>
      <span class="feeback-text" v-show="show">意见反馈</span>
    </div>
    <el-drawer :visible.sync="drawer" :with-header="false">
      <div class="drawer-container">
        <div class="drawer-title">平台使用意见反馈</div>
        <el-form ref="formData" :model="formData" :rules="rules" label-width="100px">
          <el-form-item label="意见分类：" prop="classification">
            <el-select v-model="formData.classification" placeholder="请选择意见分类">
              <el-option label="软件出错" value="1"></el-option>
              <el-option label="使用建议" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题简述：" prop="title">
            <el-input v-model="formData.title" maxlength="30" placeholder="请用30字以内简述问题"></el-input>
          </el-form-item>
          <el-form-item label="改进意见：" prop="content" class="form-item-quill">
            <el-checkbox v-model="formData.isExigency" class="urgent-checkbox">
              <el-tag type="danger">紧急</el-tag>
            </el-checkbox>
            <quill-editor
              v-model="formData.content"
              ref="myQuillEditor"
              :options="editorOption"
              class="article-editor-detail"
            ></quill-editor>
          </el-form-item>
          <el-form-item class="submit-btn">
            <el-button type="primary" @click="onSubmit('formData')" :loading="isloading" round>提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script type="text/ecmascript-6">
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { RestFeedbackOutControllerAddFeedBack } from "@src/assets/js/api.js";
export default {
  name: "MyFeedback",
  data() {
    return {
      drawer: false,
      show: true,
      formData: {
        classification: "",
        title: "",
        content: "",
        contentImgs: "",
        isExigency: false
      },
      isloading: false,
      editorOption: {
        placeholder: "多行输入",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ align: [] }],
              ["link", "image"]
            ]
          }
        }
      },
      rules: {
        classification: [
          { required: true, message: "请选择意见分类", trigger: "change" }
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [
          { required: true, message: "请填写改进意见", trigger: "blur" }
        ]
      }
    };
  },
  components: { quillEditor },
  methods: {
    onSubmit(formData) {
      this.$refs[formData].validate(valid => {
        if (valid) {
          this.formData.contentImgs = this.getImages(this.formData.content);
          let imgsSize = this.judgeImgsSize();
          if (this.formData.contentImgs !== false && imgsSize) {
            this.isloading = true;
            this.addFeedBackAsync(this.formData)
              .then(res => {
                if (res.status == 0) {
                  this.$message.success(res.retValue);
                  this.isloading = false;
                  this.formData = {
                    classification: "",
                    title: "",
                    content: "",
                    contentImgs: "",
                    isExigency: false
                  };
                  this.drawer = false;
                } else {
                  this.$message.warning(res.desc);
                  this.isloading = false;
                }
              })
              .catch(error => {
                this.isloading = false;
                return;
              });
          }
        } else {
          console.log("error submit!!");
          this.isloading = false;
          return false;
        }
      });
    },
    getImages(string) {
      let imgReg = /<img.*?(?:>|\/>)/gi;
      let arr = string.match(imgReg) || "";
      if (arr) {
        if (arr.length > 4) {
          this.$message.error("最多提交四张图片");
          return false;
        } else {
          return arr.join(";");
        }
      } else {
        return "";
      }
    },
    judgeImgsSize() {
      let imgReg = /<img.*?(?:>|\/>)/gi;
      let img = this.formData.content.match(imgReg) || "";
      let arrImg = "";
      for (var j = 0; j < img.length; j++) {
        // 正则匹配，摘出img标签下的src里的内容，即capture
        img[j].replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function(
          match,
          capture
        ) {
          arrImg += capture;
        });
      }
      let strLen = arrImg.length;
      // 计算后得到的文件流大小，单位为字节
      let fileSize = parseInt(strLen - (strLen / 8) * 2);
      // 由字节转换为MB
      let size = "";
      size = (fileSize / 1024 / 1024).toFixed(2);
      console.log("size===>", size);
      if (size > 1) {
        this.$message.error("上传图片太大，请重新上传");
        return false;
      }
      return true;
    },
    // ========================
    async addFeedBackAsync(p) {
      let request = new RestFeedbackOutControllerAddFeedBack();
      request.p_classification =
        p.classification == "1" ? "软件出错" : "使用意见";
      request.p_title = p.title;
      request.p_nowUserId = sessionStorage.getItem('userid')
      request.p_content = p.content;
      request.p_contentImgs = p.contentImgs;
      request.p_isExigency = p.isExigency;
      await request.send();
      return request.result;
    }
  }
};
</script>

<style lang="scss" scoped>
.feeback-content {
  background: #248cfa;
  color: #fff;
  width: 40px;
  height: 40px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  padding: 11px 8px;
  text-align: center;
  border-radius: 40px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 999;
  position: absolute;
  top: -280px;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: height 0.3s;
  .feeback-text {
    display: none;
    margin: 6px 0;
  }
  img {
    width: 18px;
    height: 18px;
    margin: 0;
  }
}
.feeback-content:hover {
  height: 120px;
  background: #1d4570;
}
.feeback-content:hover .feeback-text {
  display: initial;
}
.drawer-container {
  padding: 40px;
  .drawer-title {
    margin-bottom: 50px;
    text-align: center;
  }
}

.submit-btn {
  padding: 0 30px;
  .el-form-item__content > .el-button {
    width: 100%;
  }
}
.form-item-quill {
  text-align: right;
  .article-editor-detail {
    text-align: left;
    height: 450px;
  }
}
</style>
<style>
.form-item-quill .article-editor-detail .ql-container {
  height: 85%;
}
.quill-editor .ql-container .ql-editor strong {
  font-weight: bold;
}
.quill-editor .ql-container .ql-editor em {
  font-style: italic;
}
.ql-snow .ql-picker {
  height: 37px;
}
</style>